import { getCurrentMonthDays } from "../../../../../../utils/dateUtils";
import { Scheduling } from "../../../../../../models/schedule";
import useMediaQuery from '@mui/material/useMediaQuery';

interface IMonthProps {
    currentDate: Date;
    consultantMonthSchedule: Scheduling[];
    setCurrentDate: (date: Date) => void;
    setScheduleViewType: (scheduleViewType: string) => void;
}

const Month = ({ currentDate, consultantMonthSchedule, setCurrentDate, setScheduleViewType }: IMonthProps) => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const weekdays = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];
    const days = getCurrentMonthDays(currentDate);

    return (
        <table className="width-100pct table-fixed">
            <thead>
                <tr>
                    {
                        
                        weekdays.map((weekday, index) => (
                            <th className={`height-20 text-medium ${isMobile ? 'text-size-10' : 'text-size-12'}`} key={index}>
                                {isMobile ? weekday.substring(0, 1) : weekday}
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    Array.from({ length: Math.ceil(days.length / 7) }).map((_, weekIndex) => (
                        <tr key={weekIndex}>
                            {Array.from({ length: 7 }).map((_, dayIndex) => {
                                let hasScheduling = false;
                                const day = days[(weekIndex * 7) + dayIndex];

                                if(day > 0) {
                                    const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
                                    hasScheduling = !!consultantMonthSchedule.find((scheduling: Scheduling) => 
                                        scheduling.date.getDate() === date.getDate() &&
                                        scheduling.date.getMonth() === date.getMonth()
                                    );
                                }
                                return (
                                    <td
                                        style={{ 
                                            height: isMobile ? 60 : 121, 
                                            width: isMobile ? 45 : 100 
                                        }}
                                        className={`
                                            text-center border 
                                            ${isMobile ? 'text-size-14' : 'text-size-18'}
                                            ${hasScheduling ? 'bg-highlight-decent' : ''}
                                            ${day < 0 ? 'text-color-gray cursor-text bg-lightest' : 'cursor-pointer'}
                                        `}
                                        onClick={() => day > 0 && [setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), day)), setScheduleViewType('day')]}
                                        key={`${weekIndex}_${dayIndex}`}
                                    >{day < 0 ? day * -1 : day}</td>
                                )})
                            }
                        </tr>
                    ))
                }
            </tbody>
        </table>
    );
}

export default Month;